import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const Icon3DCubeM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path d="M3.69684 4.04043C3.44303 3.93166 3.14909 4.04923 3.04031 4.30305C2.93153 4.55686 3.04911 4.8508 3.30292 4.95958L6.49988 6.3297V9.50001C6.49988 9.77615 6.72374 10 6.99988 10C7.27603 10 7.49988 9.77615 7.49988 9.50001V6.3297L10.6968 4.95958C10.9507 4.8508 11.0682 4.55686 10.9595 4.30305C10.8507 4.04923 10.5567 3.93166 10.3029 4.04043L6.99988 5.45602L3.69684 4.04043ZM8.07694 0.378552C7.38373 0.111934 6.61627 0.111935 5.92306 0.378552L0.961531 2.28683C0.382243 2.50964 0 3.06619 0 3.68685V10.3133C0 10.9339 0.382244 11.4905 0.961532 11.7133L5.92306 13.6216C6.61627 13.8882 7.38373 13.8882 8.07694 13.6216L13.0385 11.7133C13.6178 11.4905 14 10.9339 14 10.3133V3.68685C14 3.06619 13.6178 2.50964 13.0385 2.28683L8.07694 0.378552ZM6.28204 1.3119C6.74418 1.13415 7.25582 1.13415 7.71796 1.3119L12.6795 3.22018C12.8726 3.29445 13 3.47997 13 3.68685V10.3133C13 10.5201 12.8726 10.7057 12.6795 10.7799L7.71796 12.6882C7.25582 12.866 6.74418 12.866 6.28204 12.6882L1.32051 10.7799C1.12741 10.7057 1 10.5201 1 10.3133V3.68685C1 3.47997 1.12741 3.29445 1.32051 3.22018L6.28204 1.3119Z" />
    </svg>
  )
}

export const Icon3DCube = createIcon({
  name: 'Icon3DCube',
  l: Icon3DCubeM,
  m: Icon3DCubeM,
  s: Icon3DCubeM,
  xs: Icon3DCubeM,
})
